/* DON'T EDIT THIS FILE: edit original and run build again */ import { AlycTenantHandler } from "../../../framework/tenant-handlers/alyc-tenant-handler.ts";
import { BaseLineOptions } from "../../../framework/tenant-handlers/base-line-options.ts";
import { ComponentType, SVGProps } from "react";
import { becerraBursatilLineOptions } from "./becerra-bursatil-line-options.ts";
import { becerrabursatilTenant } from "./code.ts";
import { becerrabursatilFullLabel } from "./full-label.ts";
import { becerraBursatilLabel } from "./label.ts";

class BecerraBursatilTenantHandler extends AlycTenantHandler {
  async getAuthPageLogo(): Promise<ComponentType<SVGProps<SVGElement>>> {
    // @ts-expect-error the hook is auto generated
    return (await import("./logo-becerra.svg?react")).default;
  }

  async getSidebarPageSmallLogo() {
    return (await import("./sidebar-page-small-logo.tsx")).default;
  }
  getCode(): string {
    return becerrabursatilTenant;
  }

  getPathLabel(): string | null {
    return "becerra-bursatil";
  }

  getLabel(): string {
    return becerraBursatilLabel;
  }

  getFullLabel(): string {
    return becerrabursatilFullLabel;
  }

  getNotificationsFrom(): string {
    return "no-responder@bbpymes.com.ar";
  }

  getCuit(): string {
    return "30-70839876-0";
  }

  getCnvRegistryId(): string | null {
    return "177";
  }

  hasLufe(): boolean {
    return true;
  }

  publishesInMarketplace(): boolean {
    return true;
  }

  hasOpinionReportSection(): boolean {
    return false;
  }

  hasGrantedLineSection(): boolean {
    return true;
  }

  supportsRiskMatrix(): boolean {
    return false;
  }

  getLineOptions(): BaseLineOptions {
    return becerraBursatilLineOptions;
  }

  getMavAgentId(): number {
    return 764;
  }
}

const becerrabursatilTenantHandler = new BecerraBursatilTenantHandler();

export default becerrabursatilTenantHandler;
